module.exports = __webpack_public_path__ + "img/L3_open.7357ae50.svg";